import { createContext } from 'react'

const royaltyContext = createContext()

export default royaltyContext
